import { create } from "zustand";
import { PartComponent, PartName, SelectingPart } from "@/types/design";
import { INITIAL_PART_NAME } from "@/const/initialPartStyle";

type previewPartsState = {
	previewParts: any;
	setPreviewParts: (category: PartName, items: any[]) => void;
};

export const previewPartsStore = create<previewPartsState>((set) => ({
	previewParts: {
		hair: [],
		backHair: [],
		eyebrows: [],
		eyeline: [],
		eyes: [],
		mouth: [],
	},
	setPreviewParts: (category, items) =>
		set((state) => ({
			previewParts: {
				...state.previewParts,
				[category]: items,
			},
		})),
}));
